module.exports = __webpack_public_path__ + "img/parent-cat-3.ddbd7ede.svg";